import {
  type RentalAccessoryCheckItem,
  type ReturnDocRequest,
  type ReturnDocResponse,
} from '@kgc/rental-core/rental-dto';
import { api } from './client';

/**
 * P0-2 (FE-3) return-process API-réteg — a #491 visszavételi-jegyzőkönyv végpontok.
 *
 * Path: `/rentals/:id/...` (a controller `@Controller('rentals')`, PLURAL — a tényleges
 * route-ból verifikálva, NEM a dto-kommentből, ami `/rental/` singular-t hazudott).
 * Az api-client adja a `/api/v1` prefixet. Minden válasz `{ data: ... }` envelope.
 */

/** GET /rentals/:id/return-accessories — D3 checklist render-forrás (READ, `status:null` start). */
export async function getReturnAccessories(
  rentalId: string
): Promise<{ data: RentalAccessoryCheckItem[] }> {
  return api.get<{ data: RentalAccessoryCheckItem[] }>(`/rentals/${rentalId}/return-accessories`);
}

/**
 * POST /rentals/:id/return-doc — visszavételi-jegyzőkönyv PDF generálás.
 *
 * Body = a per-tartozék checklist-eredmény (WRITE, `status` non-nullable) + `conditionNotes`.
 * A válasz `documentId`-je a return-doc PDF Document-linkje (az esign session `documentId`-je);
 * az esign `sourceId` viszont a `rentalId` (a RENTAL_RETURN post-sign handler ezen tölti a
 * `returnSignedAt`-ot — verifikálva a `rental-return-post-sign.ts` handlerből, nem a dto-kommentből).
 * A `pdfUrl` a `GET /rentals/:id/return-doc/:docId/content`-re mutat.
 */
export async function createReturnDoc(
  rentalId: string,
  body: ReturnDocRequest
): Promise<{ data: ReturnDocResponse }> {
  return api.post<{ data: ReturnDocResponse }>(`/rentals/${rentalId}/return-doc`, body);
}
